<script setup lang="ts">
import { computed } from 'vue';
import Select from 'primevue/select';

export type LocGroupByOption = 'additions-deletions' | 'repo' | 'github-username' | 'ai-contribution' | 'team';

interface Props {
  modelValue: LocGroupByOption;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'update:modelValue': [value: LocGroupByOption];
}>();

const locGroupBy = computed<LocGroupByOption>({
  get() {
    return props.modelValue;
  },
  set(value: LocGroupByOption) {
    emit('update:modelValue', value);
  }
});

const options = [
  { value: 'additions-deletions' as const, label: 'Default', icon: 'pi pi-chart-line' },
  { value: 'repo' as const, label: 'Repository', icon: 'pi pi-box' },
  { value: 'github-username' as const, label: 'GitHub User', icon: 'pi pi-user' },
  { value: 'team' as const, label: 'Team', icon: 'pi pi-users' },
  { value: 'ai-contribution' as const, label: 'AI Contribution', icon: 'pi pi-sparkles' }
];
</script>

<template>
  <div class="loc-grouping-controls">
    <Select
      id="loc-group-by"
      v-model="locGroupBy"
      :options="options"
      optionLabel="label"
      optionValue="value"
      placeholder="Select grouping"
      size="small"
      class="w-52"
    >
      <template #value="slotProps">
        <div v-if="slotProps.value" class="flex items-center gap-2">
          <i :class="options.find(opt => opt.value === slotProps.value)?.icon" class="text-sm"></i>
          <span>{{ options.find(opt => opt.value === slotProps.value)?.label }}</span>
        </div>
        <span v-else>{{ slotProps.placeholder }}</span>
      </template>
      <template #option="slotProps">
        <div class="flex items-center gap-2">
          <i :class="slotProps.option.icon" class="text-sm"></i>
          <span>{{ slotProps.option.label }}</span>
        </div>
      </template>
    </Select>
  </div>
</template>

<style scoped>
.loc-grouping-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
